import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import { Box, Stack, Typography } from "@mui/material";

import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { TRANSLATION_BASE } from "./AppointmentTargetCalculatorDialog.utils";
import { AppointmentTargetInputs } from "./components/AppointmentTargetInputs";
import { AppointmentTargetResult } from "./components/AppointmentTargetResult";
import { useAppointmentTargetCalculator } from "./hooks/useAppointmentTargetCalculator";

export function AppointmentTargetCalculatorDialog({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  const { formik, result, monthOptions } = useAppointmentTargetCalculator();

  const title = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <CalculateOutlinedIcon color="primary" fontSize="large" />
      <Box>
        <Typography variant="h1">{t(`${TRANSLATION_BASE}.title`)}</Typography>
        <Typography variant="subtitle1" color="text.secondary">
          {t(`${TRANSLATION_BASE}.subtitle`)}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <FormDialog
      title={title}
      onClose={onClose}
      formik={formik}
      confirmDirtyClose={false}
      disableErrorNotification
      cancelLabel={t("common.close")}
      paperSx={{ maxWidth: "760px", width: "100%" }}
    >
      <Stack direction="row" gap={3}>
        <AppointmentTargetInputs formik={formik} monthOptions={monthOptions} />
        <AppointmentTargetResult result={result} />
      </Stack>
    </FormDialog>
  );
}
